function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "infinity",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "infinity",
  d: "M29.675919,2.31775701 C26.6771048,-0.77258567 21.7790416,-0.77258567 18.680267,2.31775701 L15.9813342,5.20872274 L13.2824014,2.41744548 C10.2835873,-0.672897196 5.38552409,-0.672897196 2.28674943,2.41744548 C-0.812025235,5.50778816 -0.712064762,10.5919003 2.28674943,13.682243 C5.28556361,16.7725857 10.1836268,16.7725857 13.2824014,13.682243 L15.9813342,10.8909657 L18.680267,13.682243 C21.6790812,16.7725857 26.5771443,16.7725857 29.675919,13.682243 C32.7746937,10.4922118 32.7746937,5.50778816 29.675919,2.31775701 Z M10.4835082,10.7912773 C8.98410111,12.3862928 6.48508929,12.3862928 4.98568219,10.7912773 C3.4862751,9.19626168 3.4862751,6.70404984 4.98568219,5.10903427 C6.48508929,3.51401869 8.98410111,3.51401869 10.4835082,5.10903427 L13.182441,7.90031153 L10.4835082,10.7912773 Z M26.9769862,10.7912773 C25.4775791,12.3862928 22.9785673,12.3862928 21.4791602,10.7912773 L18.680267,8 L21.3791998,5.20872274 C22.8786068,3.61370717 25.3776187,3.61370717 26.8770258,5.20872274 C28.4763933,6.70404984 28.4763933,9.29595016 26.9769862,10.7912773 Z",
  fill: "#000000",
  fillRule: "nonzero"
}));

var SvgInfinity = function SvgInfinity(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "16px",
    viewBox: "0 0 32 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfinity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infinity.0406fb0e.svg";
export { ForwardRef as ReactComponent };